import { ChangeEvent, FC } from 'react';

import { MAX_CAMPAIGN_SELECT } from 'utils/constants/dashboard';

import Checkbox from '@hh.ru/bloko/build/blocks/checkbox';
import { HoverTip } from '@hh.ru/bloko/build/blocks/drop';
import Tip, { TipPlacement } from '@hh.ru/bloko/build/blocks/drop/Tip';
import Text, { TextSize } from '@hh.ru/bloko/build/blocks/text';

import HSpacing from 'bloko/blocks/hSpacing';

import useTrls from 'hooks/translation/useTrls';

import Label from 'components/Label';

import { CampaignTabStatus, setCheckedCampaignIds } from 'store/models/dashboard';
import { useDispatch, useSelector } from 'store/utils';

import styles from 'components/CampaignCard/CampaignTitle/CampaignTitle.module.less';

interface CampaignTitleProps {
    campaignId: number;
    name: string;
    isAuction: boolean;
}

const TrlKeys = {
    title: 'campaign.auction.title',
    auction: 'campaign.auction',
    tooltip: 'CampaignCard.CampaignTitle.tooltip',
};

const CampaignTitle: FC<CampaignTitleProps> = ({ campaignId, name, isAuction }) => {
    const campaignTabsStatus = useSelector((state) => state.campaignTabsStatus);
    const checkedCampaignIds = useSelector((state) => state.dashboard.checkedCampaignIds);

    const isCheckboxDisabled =
        Object.keys(checkedCampaignIds).length >= MAX_CAMPAIGN_SELECT && !checkedCampaignIds[campaignId];

    const trl = useTrls();
    const dispatch = useDispatch();

    const onCampaignCheckboxToggle = (event: ChangeEvent<HTMLInputElement>) => {
        const checked = event.target.checked;
        const newCheckedCampaignIds = { ...checkedCampaignIds };
        if (checked) {
            newCheckedCampaignIds[campaignId] = true;
            dispatch(setCheckedCampaignIds(newCheckedCampaignIds));
        } else {
            delete newCheckedCampaignIds[campaignId];
            dispatch(setCheckedCampaignIds(newCheckedCampaignIds));
        }
    };

    return (
        <div className={styles.campaignTitleWrapper}>
            {campaignTabsStatus === CampaignTabStatus.Active && (
                <>
                    <HoverTip
                        show={isCheckboxDisabled}
                        placement={TipPlacement.Bottom}
                        render={() => <Text>{trl(TrlKeys.tooltip, [MAX_CAMPAIGN_SELECT])}</Text>}
                        DropElement={Tip}
                    >
                        <div className={styles.campaignTitleCheckbox}>
                            <Checkbox
                                checked={checkedCampaignIds[campaignId] || false}
                                disabled={isCheckboxDisabled}
                                onChange={onCampaignCheckboxToggle}
                                data-qa={`campaign-checkbox-${String(campaignId)}`}
                            />
                        </div>
                    </HoverTip>
                    <HSpacing base={1} />
                </>
            )}
            <div className={styles.campaignTitle}>
                <Text size={TextSize.ExtraLarge} data-qa="campaign-block__title">
                    {isAuction ? trl(TrlKeys.title) : name}
                </Text>
                {isAuction && (
                    <>
                        <HSpacing base={2} />
                        <Label type="success">{trl(TrlKeys.auction)}</Label>
                    </>
                )}
            </div>
        </div>
    );
};

export default CampaignTitle;
